@import (reference) '../../../constants/spacing.module.less';

.pageContainer {
  padding: @space-32;
  min-height: 100%;
  height: 100%;
  overflow-y: auto;
}

.contentContainer {
  max-width: 600px;
  margin: @space-40 auto;
}

.card {
  border: 1px solid var(--grey-300);
  border-radius: 8px;
  padding: @space-32;
}

.installButton button {
  background-color: var(--green-500);
  border-color: var(--green-500);
  color: var(--white);
}

.appIcon {
  width: 64px;
  height: 64px;
  border-radius: 8px;
  object-fit: cover;
}

.scopesCard {
  background: var(--grey-100);
  border-radius: 4px;
  padding: @space-16;
}

.scopeItem {
  font-family: monospace;
  font-size: 13px;
}

.successIcon {
  color: var(--green-500);
  font-size: 48px;
}

.errorText {
  color: var(--red-500);
}

.centerItems {
  align-items: center;
}

.centerContent {
  justify-content: center;
}

.dimText {
  color: var(--grey-500);
}
